import NotasNivel2 from '../../produto/spa/notas/NotasNivel2';

export default NotasNivel2;
